<template>
  <HeaderComponent />
  <RouterView />
</template>

<script setup lang="ts">
import HeaderComponent from '@/components/header/HeaderComponent.vue'
</script>
